__turbopack_context__.v({
  "Content": "footer-module-scss-module__hIP8pa__Content",
  "mailLink": "footer-module-scss-module__hIP8pa__mailLink",
});
